import brainVisual from '../assets/brain/translucent-brain-rainbow-core.jpg';
import { capabilities } from '../data/content';
import CapabilityCard from './CapabilityCard';

const desktopPositions = [
  'lg:absolute lg:left-8 lg:top-16 lg:w-[12rem]',
  'lg:absolute lg:left-10 lg:bottom-24 lg:w-[12.75rem]',
  'lg:absolute lg:right-8 lg:top-16 lg:w-[12.75rem]',
  'lg:absolute lg:right-8 lg:bottom-24 lg:w-[12.5rem]',
  'lg:absolute lg:left-1/2 lg:bottom-8 lg:w-[12rem] lg:-translate-x-1/2',
  'lg:absolute lg:left-1/2 lg:top-7 lg:w-[12.5rem] lg:-translate-x-1/2',
];

export default function BrainMap() {
  return (
    <section id="capabilities" className="brain-visual relative mx-auto w-full max-w-[39rem]" aria-labelledby="capabilities-title">
      {/* Future animation: floating brain glow */}
      <h2 id="capabilities-title" className="sr-only">Relate.ai capabilities</h2>
      <div className="liquid-panel relative min-h-[31rem] overflow-hidden p-5 sm:p-7 lg:min-h-[43rem]">
        <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-br from-violet-200 via-white to-rose-200 blur-3xl" aria-hidden="true" />
        <img src={brainVisual} alt="Translucent AI brain with rainbow intelligence core" className="relative z-10 mx-auto mt-10 h-56 w-56 rounded-full object-cover object-center mix-blend-multiply drop-shadow-2xl sm:h-64 sm:w-64 lg:mt-28" />
        <div className="relative z-20 mt-7 grid gap-3 sm:grid-cols-2 lg:contents">
          {capabilities.map((capability, index) => (
            <CapabilityCard key={capability.title} {...capability} className={desktopPositions[index]} />
          ))}
        </div>
      </div>
    </section>
  );
}
